module.exports = __webpack_public_path__ + "media/images/icons/v2/chevron-down-46c6f0079fa7f843afb69aac5ac870ba.svg";